export default __webpack_public_path__ + "images/WaterletHandOutline-Regular.font.7dd38b1216e02faf7cc69b8fc12d82e4.svg";